import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=cd4872f4&scoped=true&"
import script from "./notes.vue?vue&type=script&lang=js&"
export * from "./notes.vue?vue&type=script&lang=js&"
import style0 from "./notes.vue?vue&type=style&index=0&id=cd4872f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4872f4",
  null
  
)

export default component.exports